export default {

  namespaced: true,

  state: () => ({

    selectedAccountId : null, 

    accounts: []

  }),

  getters: {

    selectedAccount(state) {
      return state.accounts.filter((account) => account.id == state.selectedAccountId)[0]
    },
    

    allowedAccounts(state, getters, rootState, rootGetters) {
      return state.accounts.filter((account) => {
        if (account.status == '0') {
          return false
        }

        if (account.free_access == '1') {
          return true
        }

        let userArr = account.account_permission_join_user.filter((accountPermission) => accountPermission.user_id == rootState.auth.user.user.id);

        if (userArr.length > 0) {
          return true
        }

        return false
      });
    }
  },

  mutations: {
    setAccounts(state, accounts) {
      state.accounts = accounts
    },

    setSelectedAccount(state, accountId) {
      state.selectedAccountId = accountId
    }
  },

  actions: {

    async getAccounts({ commit }, params) {
      await axios.get("/erp/account/account", { params: params })
        .then(response => {

          commit('setAccounts', response.data.accounts)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    },

    async storeAccount({ dispatch, commit, params }) {
      await axios.post("/erp/account/account", params)
        .then(response => {

          commit('setAccounts', response.data)

        }).catch(error => { 

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    }

  }
}
